import * as regions from 'src/api/regions'
import router from 'src/router'
import {
  GET_REGION,
  GET_ALL_REGIONS
} from 'src/store/mutation-types'

const getAllRegion = ({commit, dispatch}, configs = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  regions.getAllRegion(configs).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_REGIONS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_REGIONS, [])
    }
  })
}

const getRegion = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  regions.getRegion(configs).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_REGION, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Vùng miền không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'region'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setRegion = ({commit}, region) => {
  commit(GET_REGION, region)
}

export default{
  getRegion,
  getAllRegion,
  setRegion
}



// WEBPACK FOOTER //
// ./src/components/region/store/actions.js